/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TrimbleLinkControllerLinkMutationResponse } from "../../models/authController/TrimbleLinkControllerLink";

function getTrimbleLinkControllerLinkUrl() {
  const res = { method: 'POST', url: `/api/v1/auth/trimble/link` as const }  
  return res
}

/**
 * @summary Link/provision a Principal from a verified Trimble id_token
 * {@link /api/v1/auth/trimble/link}
 */
export async function trimbleLinkControllerLink(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<TrimbleLinkControllerLinkMutationResponse, ResponseErrorConfig<Error>, unknown>({ method : "POST", url : getTrimbleLinkControllerLinkUrl().url.toString(), ... requestConfig })  
  return res.data
}